import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';

import {WsSpa} from '../../services/wsSpa';

@Component({
  selector: 'app-cidades',
  templateUrl: './cidades.component.html'
})
export class CidadesComponent implements OnInit {

  @Output() selectCidade: EventEmitter<any> = new EventEmitter();
  @ViewChild('buscaCidades') buscaCidades;
  @ViewChild('alert') alert;

  public cidades;
  public offset = 0;
  public loading = false;

  constructor( private wsSpa: WsSpa ) {}

  ngOnInit() {
    this.getCidades();
  }

  public show() {
    this.buscaCidades.show();
  }
  public hide() {
    this.buscaCidades.hide();
  }

  public getCidades() {
    this.wsSpa.getFunction('get', 'cidade', 'spaUrl')
      .subscribe(
        data => this.cidades = data,
        error => this.trataErro(error.message),
        () => this.loading = false
      );
  }

  public searchCidades(parametro) {
    parametro = parametro.replace(/[^\w\s]/gi, '');
    if (parametro) {
      this.wsSpa.getFunction('search/cidade', parametro, 'spaUrl')
        .subscribe(
          data => this.cidades = data,
          error => this.trataErro(error.message),
          () => this.loading = false
        );
    } else {
      this.getCidades();
    }
  }

  public trataErro(error) {
    this.loading = false;
    this.alert.danger(error);
  }

  public onSelect(cidade, nome) {
    const cid = {codigo: cidade, nome: nome};
    this.selectCidade.emit(cid);
    this.hide();
  }

}
